import { handleActions } from 'redux-actions'
import { actions } from '../actions/sessions'

const defaultState = {
    sessions: {}
}

const setSessions = (state, action) => {
    const { weekKey, value } = action.payload;
    
    // Check if the session key already exists
    if (state.sessions[weekKey]) {
        return state; // Return the existing state if the key exists
    }

    // Otherwise, add the new session key-value pair
    return {
        ...state,
        sessions: {
            ...state.sessions,
            [weekKey]: value
        }
    };
}

const resetSessions = (_state, _action) => {
    return defaultState
}

export default handleActions({
    [actions.setSessions]: setSessions,
    [actions.resetSessions]: resetSessions,
}, defaultState)



// WEBPACK FOOTER //
// ./src/store/reducers/sessions.js